import { notification } from "antd";
import api from "../api";
import { customAuthorizationMiddleware } from "./custom-authorization";

export const Interceptors = () => {    
    api.interceptors.request.use((request) => {
        return customAuthorizationMiddleware(request);
    })
    api.interceptors.response.use(undefined, error => {
        if (error.response.config.baseURL.indexOf('id.ms.gov.br') === -1) {
            if (error.response.status === 401) {
                notification.config({
                    maxCount: 1
                })
                notification.error(
                    {                        
                        message: <strong style={{
                            color: "black",
                            fontFamily:"Helvetica",
                            fontSize: 18, fontWeight:20
                        }}>Sessão encerrada</strong>,
                        description: <b style={{
                            color: "black",
                            fontSize: 15
                        }}>
                            <a href="/" style={{ textDecoration: "underline", fontWeight: 10, color: "blue" }}>
                                Clique aqui</a> para poder utilizar o sistema novamente!
                        </b>
                        ,
                        duration: 0
                    })
                    sessionStorage.clear()

            }
        }
        return Promise.reject(error)
    })


}